import React, {useEffect, useState} from 'react';
import Header from "./Header";
import {Link, useParams} from 'react-router-dom';
import Footer from "./footer";
import {RankingTable} from "./RankingTable";
import {Team} from "./types";
import {Game} from "./Game";
import {loadFavorite} from "./favoriteStore";
import {FontAwesomeIcon} from '@fortawesome/react-fontawesome';
import {faStar as solidStar} from '@fortawesome/free-solid-svg-icons';
import {faStar as regularStar} from '@fortawesome/free-regular-svg-icons';


let Group: React.FC;

Group = () => {
    const {teamId, groupId} = useParams();
    const [games, setGames] = useState([{
        tag: "0",
        txtTeamA: "",
        resultatA: "",
        resultatB: "",
        txtTeamB: "",
        zeit: "",
        runde: "",
        halle: "",
    }]);

    const [favorite, setFavorite] = useState(false);

    const [teams, setTeams] = useState<Team[]>([]);
    const [current, setCurrent] = useState<Team | undefined>(undefined);

    useEffect(() => {
        async function fetchGames() {
            const games = await fetch(`https://korbball.turnverband.ch/ws/gamesV1.php?team=${teamId}`).then(response => response.json());
            setGames(games);
        }

        fetchGames();
        setFavorite(loadFavorite(teamId)); //sonst würde der Favorit bei wechseln auf Ansicht nicht angepasst

    }, [teamId]);

    const next_games = games.filter(game => game.resultatA === "");
    const played_games = games.filter(game => game.resultatA !== "");

    useEffect(() => {
        async function fetchTeams() {
            const teamsResponse = await fetch(`https://korbball.turnverband.ch/ws/rankingV1.php?group=${groupId}`).then(response => response.json());

            const teams: any[] = [];

            Object.keys(teamsResponse).forEach(function (key: any) {
                teams.push(teamsResponse[key]);
            });

            if (teamId) {
                setCurrent(teams.filter(g => (g.teamId === parseInt(teamId)))[0]);
            }


            setTeams(teams);
        }

        fetchTeams();
    }, [groupId, teamId]);


    var neighbourhood = teams;
    if (current) {
        neighbourhood = teams.filter(t => {
            const abs = Math.abs(t.rank - current.rank);

            if ((current.rank === 1) || current.rank === teams.length) {
                return abs <= 2;
            }
            return abs <= 1;
        });
    }

    function toggleFavorite(id ?: string) {
        if (id && groupId && current) {
            const favorites_str = localStorage.getItem('favorites');
            let favorites_json = favorites_str ? JSON.parse(favorites_str) : [];

            let favorites_filter = favorites_json.filter((element: { id: string; }) => (element.id !== id));

            if (favorites_filter.length < favorites_json.length) {
                favorites_json = favorites_filter;
                setFavorite(false);
            } else {
                var team_name = current.team;
                favorites_json.push({id, groupId, team_name});
                setFavorite(true);
            }

            localStorage.setItem('favorites', JSON.stringify(favorites_json));
        }
    }


    return (
        <div className="App">
            <Header/>
            <div className="App-container">
                <h2>
                    {current && current.team}
                    <span onClick={() => toggleFavorite(teamId)}>
                        {favorite ? <FontAwesomeIcon icon={solidStar} title="Aus Favoriten entfernen"/> :
                            <FontAwesomeIcon icon={regularStar} title="Zum Favoriten machen"/>}
                    </span>
                </h2>
                <h3>Tabelle</h3>
                <RankingTable teams={neighbourhood} groupId={groupId || ""}/>
                <Link className="tabelle_link" to={'/group/' + groupId}>Alle ansehen ></Link>
                {played_games.length > 0 && <>
                    <h3>Letzte Spiele</h3>
                    <table className="games table">
                        <tbody>
                        {played_games.map(game => (
                            <Game game={game}/>
                        ))}
                        </tbody>
                    </table>
                    <br/>
                </>}
                {next_games.length > 0 && <>
                    <h3>Nächste Spiele</h3>
                    <table className="games table">
                        <tbody>
                        {next_games.map(game => (
                            <Game game={game}/>
                        ))}
                        </tbody>
                    </table>
                </>}
                <p>
                </p>
                <ul>
                </ul>
            </div>
            <Footer/>
        </div>
    );
};

export default Group;
